/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Inject, Injectable} from '@angular/core';

import {DOCUMENT} from '../dom_tokens';

import {EventManagerPlugin} from './event_manager';
export class DomEventsPlugin extends EventManagerPlugin {
/**
 * @param {?} doc
 */
constructor( doc: any) { super(doc); }
/**
 * @param {?} eventName
 * @return {?}
 */
supports(eventName: string): boolean { return true; }
/**
 * @param {?} element
 * @param {?} eventName
 * @param {?} handler
 * @return {?}
 */
addEventListener(element: HTMLElement, eventName: string, handler: Function): Function {
    element.addEventListener(eventName, /** @type {?} */(( handler as any)), false);
    return () => element.removeEventListener(eventName, /** @type {?} */(( handler as any)), false);
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: undefined, decorators: [{ type: Inject, args: [DOCUMENT, ] }, ]},
];
}

function DomEventsPlugin_tsickle_Closure_declarations() {
/** @type {?} */
DomEventsPlugin.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DomEventsPlugin.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
